import { Popup } from './popup';

const popupCalls = {
  init() {
    const menu = new Popup('#jsMenuWrap', '.jsOpenMenu', '#jsCloseMenu');
    menu.init();

    const account = new Popup(
      '#jsAccountWrap',
      '#jsOpenAccount',
      '#jsCloseAccount',
    );
    account.init();

    const cart = new Popup('#jsCartWrap', '#jsOpenCart', '#jsCloseCart');
    cart.init();

    const help = new Popup('#jsHelpWrap', '.jsOpenHelp', '#jsCloseHelp');
    help.init();

    const filters = new Popup(
      '#jsFiltersWrap',
      '#jsOpenFilters',
      '#jsCloseFilters',
    );
    filters.init();

    const sort = new Popup('#jsSortWrap', '#jsOpenSort', '.jsCloseSort');
    sort.init();

    const gallery = new Popup(
      '#jsGalleryWrap',
      '#jsOpenGallery',
      '#jsCloseGallery',
    );
    gallery.init();

    window.addEventListener('reset', () => {
      const gallery = new Popup(
        '#jsGalleryWrap',
        '#jsOpenGallery',
        '#jsCloseGallery',
      );
      gallery.init();
    });
  },
};

export default popupCalls;
